export default __webpack_public_path__ + "static/media/93.956c42cd.jpg";